module.exports = __webpack_public_path__ + "img/dogecoin.1c6cfd28.png";